// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fNGFStNKkpxqggL9ign3{font-family:AccordAltThin,Helvetica,sans-serif;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:16px;text-align:center}.hXQ9DwgTORwF2F5g3zBN{margin-bottom:8px}.rMOdH1Llw5_fPheBLK6n{font-size:16px;text-transform:capitalize;padding-bottom:10px}.tN8CtWm0_Kk4VxZutl3d{font-size:28px;font-weight:bold}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"discoverContainer": "fNGFStNKkpxqggL9ign3",
	"titleContainer": "hXQ9DwgTORwF2F5g3zBN",
	"brandLabel": "rMOdH1Llw5_fPheBLK6n",
	"brandName": "tN8CtWm0_Kk4VxZutl3d"
};
export default ___CSS_LOADER_EXPORT___;
